import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_SHOP } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Payment',
        key: 'Shop',
        name: 'Shop',
        icon: 'fa fa-store',
        route: { name: ROUTE_NAME_SHOP.INDEX }
    }
]);

export default registerRouteForModule(router);
